module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-rec-details/landrec-grid/landrec-grid.component.css
// module id = ./src/app/landprocurement/land-rec-details/landrec-grid/landrec-grid.component.css
// module chunks = main